<template>
  <div id="app">
    <Header></Header>
    <div class="us" v-if="isTop">
      <div class="us-item" @click="top">
        <div class="cricle top"></div>
        <div class="us-font">{{ $lang('回到顶部') }}</div>
      </div>
    </div>
    <router-view :key="i18nKey"/>
  </div>
</template>
<script>
import Header from "./views/home/NewHeader"
import axios from 'axios'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'App',
  components: {
      Header,
  },
  data() {
    return {
      isTop: false,
      scrollTop: 0,
      timer: null,
      downScroll: false,
      i18nKey: new Date().getTime()
    }
  },
  computed: {
    ...mapGetters(['lang']),
  },
  mounted() {
    // 向页面添加股东事件
    window.addEventListener('scroll', this.handleScroll, true)
    window.addEventListener('wheel', this.moveWheel, false);
    this.getLang()
  },
  watch: {
    '$route.path': {
      deep: true,
      handler() {
        document.documentElement.scrollTop = 0
      }
    },
    // 监听国际化语种字段，有更新且不为空时重新获取国际化数据，同时更新缓存中的国际化数据
    lang: {
      handler(val, nval) {
        if (val && val !== nval) {
          this.getI18nData(val, nval)
          // 设置html page lang
          document.documentElement.lang = val && val.toLowerCase()
          if (val && val.toLowerCase() === 'ar') {
            document.documentElement.dir = 'rtl'
          } else {
            document.documentElement.dir = 'ltr'
          }
        }
      },
      // 初始化的时候执行
      immediate: true,
    }
  },
  methods:{
    ...mapActions(['SET_LANG_JSON', 'SET_DEFAULT_LANG', 'SET_LANG_LIST']),
    async getLang() {
      const { data: { code, data = [] } = {}} = await axios.get(`${process.env.VUE_APP_in18_URL}/dictionary/getLang`)
      if (code === 1) {
        const list = data.map(item => ({ label: item.label, value: item.val, local: item.local })) //
        // 更新store中语言列表
        this.SET_LANG_LIST(list)
      }
    },
    // 获取国际化数据
    async getI18nData(lang, oldLang) {
      try {
        const { data: { code, data } = {}} = await axios.get(`${process.env.VUE_APP_in18_URL}/sysInternational/getSysInternationalList`, {
          params: {},
          headers: {
            langType: lang,
          },
        })
        if (code === 1) {
          // 更新store中国国际化数据
          this.SET_LANG_JSON(data).then(() => {
            // 更新路由key，保证页面内的界面重载更新语言数据
            this.i18nKey = !oldLang ? this.i18nKey : new Date().getTime()
          })
        }
      } catch (error) {
        console.log(error, 'error')
      }
    },
    moveWheel(e) {
      let timerWheel = null;
      e = window.event;
      if (e.wheelDelta < 0) {
        this.downScroll = true;
      }
      clearTimeout(timerWheel);
      timerWheel = setTimeout(() => {
        this.downScroll = false;
      }, 200);
    },
    top() {
      clearInterval(this.timer);
      this.timer = setInterval(()=>{
        var temp = this.scrollTop / 10
        temp = temp > 0 ? Math.ceil(temp) : Math.floor(temp)
        if (this.scrollTop === 0 || this.downScroll) {
          clearInterval(this.timer)
        }
        document.documentElement.scrollTop = this.scrollTop - temp;
      },10)
    },
    handleScroll() {
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      const windowHeight = document.body.clientHeight
      this.isTop = this.scrollTop / windowHeight * 100 > 35 ? true : false
    }
  }
}
</script>
<style lang="scss">
html:lang(vn), html:lang(en){
  .register .reg-content .reg-box .reg-desc {
    right: 26px;
    display: flex;
    flex-direction: column;
    .desc-title {
      width: 278px;
      font-size: 18px;
    }
    .desc-text {
      width: 278px;
      font-size: 16px;
    }
  }

  //帮助中心优化
  .helpCenter-wrap .main-left .main-left-aside .subTitle .font-style {
    padding-left: 14px;
  }
}
</style>
<style lang="scss">
//全局导航优化
.header .header-content .header-menu {
  width: 1000px !important;
  font-size: 14px;
}
.header .header-content .header-menu .header-menu-item {
  margin-left: 30px !important;
}
.cupopper {
  width: 150px !important;
  height: 200px !important;
}
</style>
<style lang="scss" scoped>
#app {
  min-width: 1400px;
  overflow: auto;
}
.us {
  z-index: 500;
  position: fixed;
  right: 10px;
  bottom: 200px;
  .cricle {
    width: 45px;
    height: 45px;
    background-color: rgba(230, 0, 0, 0.5);
    border-radius: 50%;
    margin-bottom: 5px;
  }
  .top {
    background: rgba(230, 0, 0, 0.65) url("./assets/images/newHome/top.png") no-repeat center center;
    background-size: 20px 20px;
  }
  .us-icon {
    background: rgba(230, 0, 0, 0.65) url("./assets/images/newHome/us.png") no-repeat center center;
    background-size: 30px 30px;
  }
  .us-item {
    margin: 20px 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .us-item:hover {
    cursor: pointer;
    color: #E60000;
    .cricle {
      background-color: rgba(230, 0, 0, 1);
      box-shadow: 0 0px 5px 0 rgba(230, 0, 0, 1)
    }
  }
  .us-font {
    font-size: 14px;
    font-weight: 400;
    color: #E60000;
  }
}
</style>
<style lang="scss">
@import "./assets/iconfontNew/iconfont.css";
@import "./assets/iconfont/iconfont.css";
#app{
    height: 100%;
}
$bg: rgba(0, 0, 0, 0.1);
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
/*滚动条小方块*/
::-webkit-scrollbar-thumb {
  background-color: #B2B2B2;
  -webkit-border-radius: 5px; /* Safari 和 Chrome */
  -moz-border-radius: 5px; /* Firefox */
  -o-border-radius: 5px; /* Opera */
  border-radius: 5px;
}
/*滚动轨道两端按钮*/
::-webkit-scrollbar-button {
  -webkit-box-shadow: inset 0 0 5px $bg;
  background-color: $bg;
}
/*滚动轨道 内阴影*/
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px $bg;
  background-color: $bg;
}
</style>
